"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports["default"] = exports.Directory = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _simple = _interopRequireDefault(require("./simple"));
/**
 * The Directory is a searchable registry
 */


var Directory =
/*#__PURE__*/
function (_SimpleDirectory) {
  (0, _inherits2["default"])(Directory, _SimpleDirectory);
  /**
   * Create a new Simple Registry
   * @param  {String} name   The name of this registry
   * @param  {Object} options =             {} Options
   * @param  {Function} options.init a function which will be called with the registry after it is initialize.
   * @param  {Function} options.fallback called whenever an invalid lookup request returns
   *
   * @param {String} route an express or path-to-regexp style route which turns the id into metadata
   * @return {SimpleRegistry}        The SimpleRegistry
   */

  function Directory(name) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, Directory);

    if (!options.route) {
      options.route = ':id(.*)';
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Directory).call(this, name, options));

    if (options.api) {
      Object.keys(options.api).forEach(function (meth) {
        _this[meth] = options.api[meth].bind((0, _assertThisInitialized2["default"])(_this));
      });
    }

    if (options.lookupMethod) {
      var me = (0, _assertThisInitialized2["default"])(_this);
      Object.assign((0, _assertThisInitialized2["default"])(_this), (0, _defineProperty2["default"])({}, options.lookupMethod, me.lookup.bind(me)));
    }

    _this.attach('metadata', {
      fallback: function fallback(id) {
        return {
          notFound: true,
          id: id
        };
      }
    });

    return _this;
  }

  (0, _createClass2["default"])(Directory, [{
    key: "search",
    value: function search() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var reg = this;
      var items = this.metadata.available.map(function (id) {
        return reg.meta(id);
      }).filter(function (r) {
        return !r.notFound;
      });
      return this.query(items, params);
    }
  }, {
    key: "meta",
    value: function meta(id) {
      var updateData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var result = this.metadata[id] || {};
      return this.metadata[id] = (0, _objectSpread2["default"])({}, result, this.testRoute(id) || {}, updateData);
    }
  }, {
    key: "applyRoute",
    value: function applyRoute(route) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.router.get(route || this.options.route);
    }
  }, {
    key: "testRoute",
    value: function testRoute(path, route) {
      route = route || this.options.route;
      return this.router.test(route)(path);
    }
  }, {
    key: "register",
    value: function register(id, fn) {
      var _this2 = this;

      var metadata = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this._register(id, fn);

      this.metadata.register(id, function () {
        return (0, _objectSpread2["default"])({}, metadata, {
          registryId: id
        }, _this2.testRoute(id) || {});
      });
      return this;
    }
  }]);
  return Directory;
}(_simple["default"]);

exports.Directory = Directory;
var _default = Directory;
exports["default"] = _default;

var create = function create() {
  return Directory.create.apply(Directory, arguments);
};

exports.create = create;